import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
    toggle: String,
    // Opt in to "turbo-stream" where the response has to re-render state that
    // depends on the setting -- request.js renders the stream itself. The
    // default keeps existing callers on a fire-and-forget PATCH.
    responseKind: { type: String, default: "html" },
  };

  connect() {}

  toggleSetting() {
    patch(this.urlValue, {
      body: { toggle: this.toggleValue },
      responseKind: this.responseKindValue,
    });
  }
}
